var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-content text-center py-5"},[_c('h4',{staticClass:"no-info text-muted"},[_vm._v("页面发生错误")])])}]

export { render, staticRenderFns }